Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "offeringimage2271093387",
  {"partContainer":"offeringimage2271093387--partContainer","mobile":"offeringimage2271093387--mobile","hoveredDescription":"offeringimage2271093387--hoveredDescription","imageContainer":"offeringimage2271093387--imageContainer","descriptionContainer":"offeringimage2271093387--descriptionContainer","mixin-image-box":"offeringimage2271093387--mixin-image-box","image-square":"offeringimage2271093387--image-square","image-round":"offeringimage2271093387--image-round","emptyImage":"offeringimage2271093387--emptyImage","image-none":"offeringimage2271093387--image-none","visible":"offeringimage2271093387--visible","hidden":"offeringimage2271093387--hidden","root":"offeringimage2271093387--root"},
  "",
  1,
  "offeringimage2271093387"
);

